import { loginService } from '@services/auth';
import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import { useUserAnalytics } from '../hooks/useUserAnalytics';
import { AUTH_EVENTS } from '../utils/eventSchema';
import { setAccessToken } from '../utils/authTokenStore';

export const useLogin = () => {
  const { trackEvent } = useUserAnalytics();
  return useMutation({
    mutationFn: loginService,
    onSuccess: (response) => {
      if (response?.mfa_required) {
        return;
      }
      if (response?.access_token) {
        setAccessToken(response.access_token);

        // Identify user for analytics
        identifyUserWithProfile(response.user);

        // Track login success
        trackEvent('auth', {
          ...AUTH_EVENTS.LOGIN_SUCCESSFUL,
          login_time: new Date().toISOString(),
          login_method: 'password',
          device: navigator.userAgent,
        });
      }
    },
    onError: (error) => {
      console.error('Login failed:', error);
      const detail = error.response?.data?.detail;
      if (detail?.code === 'PASSWORD_EXPIRED') {
        return;
      }
      if (detail?.code === 'ACCOUNT_LOCKED') {
        return;
      }
      if (detail?.code === 'RATE_LIMIT_EXCEEDED') {
        toast.error('Too many sign-in requests. Please wait a minute and try again.', {
          autoClose: 5000,
        });
        return;
      }
      toast.error(detail?.message || detail || 'Unable to login', {
        autoClose: 3000,
      });
    },
  });
};

const identifyUserWithProfile = (user) => {
  if (window.analytics && user) {
    const { id, email, first_name, last_name } = user;
    window.analytics.identify(id, {
      email,
      firstName: first_name,
      lastName: last_name,
      name: `${first_name} ${last_name}`,
    });
  }
};
